// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bountyId: __t.u64().primaryKey().name("bounty_id"),
  target: __t.identity(),
  phase: __t.string(),
  materialized: __t.bool(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  revision: __t.u32(),
  domainEpoch: __t.u32().name("domain_epoch"),
  since: __t.timestamp(),
  updatedAt: __t.timestamp().name("updated_at"),
});
